
import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useTableNavigation from '../../../../ui/tables/useTableNavigation';

import { ApplicableTableSettings, codesRegionUnLocationCodeList } from '../../../../tableSettings';

import {
  TextAlignLeftRenderer,
  TextRenderer,
} from '../../../../uiControls/SmartTableRenderers';

import SmartTable from '../../../../uiControls/SmartTable';

import useFastStorage, { useTypedFastStorage } from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';

import ApplicationContext from '../../../../ApplicationContext';
import SecondaryButton from '../../../../ui/SecondaryButton';
import { Search, initialSearch, isFilterObjectEmpty } from '../../../../filtering';
import { JobNames } from '../../../../framework.core/JobNames';
import { CodeUNLocationListItem } from '../../../../fms.data/models/CodeUNLocationListItem';
import { FmsSecTask } from '../../../../fms.core/constants';
import IfmsModal from '../../../../ui/IfmsModal';
import InlineInputControlRow from '../../../../ui/layout/InlineInputControlRow';
import TextBox from '../../../../ui/TextBox';
import useDirtyCheck from '../../../../hooks/useDirtyCheck2';
import { ApiResult } from '../../../../framework.core/data/ApiResult';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import LeftRightSplit from '../../../../ui/LeftRightSplit';
import IsoCountryDropDown from '../../../../uiControls/IsoCountryDropDown';
import { CodeOceanUnPort } from '../../../../fms.core/CodeOceanUnPort';
import { checkPropDirty, getSQLInfoList } from '../../../../fms.core/data/TrackingModule';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import { sortingListData } from '../../ReferenceFiles';
import { findSecurityTask } from '../../../../util';
import useFilterBar from '../../../../hooks/useFilterBar';
import { ListOrderBy } from "../../../common/AbstractListView";
import postal from 'postal';
import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import { Portal } from 'react-portal';
import CloseButton from '../../../../ui/CloseButton';


function UnLocDetails({
  readonly,
  unLoc,
  onChange
}:{
  readonly: boolean,
  unLoc:CodeOceanUnPort,
  onChange: (change: Partial<CodeOceanUnPort>) => void
}) {
  return (
    <div>
        <div style={{width:'500px'}}>
        <InlineInputControlRow label="UN Code" mode="smaller-2x">
            <LeftRightSplit
            leftSize="60px"
            rightSize="calc(100% - 60px)"
            left={
              <IsoCountryDropDown
              maxLength={2}
              name='unloc-unCountryCombo'
              value={unLoc.unCountry}
              disabled={readonly}
              onChange={country => onChange({unCountry: country?.value??'', unCountryName: country?.text??'', unCode: country?.value + unLoc.unCodeSub.toUpperCase() })}
            />
            }
            right={
              <div style={{display:"flex"}}>
                
                <TextBox name='unloc-subcode' style={{width:'100px'}} maxLength={3} disabled={readonly} value={unLoc.unCodeSub} onChange={e => onChange({unCodeSub: e.target.value, unCode: unLoc.unCountry + e.target.value.toUpperCase()})} />
                <TextBox name='unloc-unCode' style={{width:'150px'}} disabled value={unLoc.unCode} />
                <span>&nbsp;(Fixed Len: 5)</span>
              </div>
            }
            />
          </InlineInputControlRow> 
        </div>
        <div style={{width:'420px'}}>
          <InlineInputControlRow label="UN Location" mode="smaller-2x">
            <TextBox name='unloc-unPortName' maxLength={35} disabled={readonly} value={unLoc.unPortName} onChange={e => onChange({unPortName: e.target.value})} />
          </InlineInputControlRow>
          <InlineInputControlRow label="Country" mode="smaller-2x">
            <LeftRightSplit
            leftSize="60px"
            rightSize="calc(100% - 60px)"
            left={
                <TextBox name='unloc-unCountry' disabled value={unLoc.unCountry} onChange={e => onChange({unCountry: e.target.value})} />
            }
            right={
              <TextBox name='unloc-unCountryName' disabled value={unLoc.unCountryName} onChange={e => onChange({unCountryName: e.target.value})} />
            }
            />
          </InlineInputControlRow> 

          <InlineInputControlRow label="US Code" mode="smaller-2x">
            
            <TextBox name='unloc-usCode' maxLength={10} disabled={readonly} value={unLoc.usCode} onChange={e => onChange({usCode: e.target.value})} />
          </InlineInputControlRow>
      </div>
    </div>
  );
}


// function ActionRenderer({ data, row }: any) {
//   return (
//     <div style={{textAlign: 'left', marginLeft: '10px'}}>
//       { data[row.index].listSec?.grantDel && 
//         <PrimaryInverseButton
//           disabled={data[row.index].editIndex !== row.index}
//           style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//           data-tooltip="Delete"
//           
//           onClick={() => data[row.index].onDelete()}
//         >
//           <FontAwesomeIcon icon={faTrashAlt} />
//         </PrimaryInverseButton>
//       }
//       &nbsp;&nbsp;
      
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Save"
//         
//         onClick={() => data[row.index].onSave()}
//       >
//         <FontAwesomeIcon icon={faSave} />
//       </PrimaryInverseButton>
//     </div>
//   );
// }

function UnCodeRenderer({data, row, cell}: any) {
  return <TextRenderer row={row} cell={cell} />;
}

function UnPortNameRenderer({data, row, cell}: any) {
  return <TextAlignLeftRenderer row={row} cell={cell} />;
}

function UnCountryRenderer({data, row, cell}: any) {
  return <TextRenderer row={row} cell={cell} />;
}

function UsCodeRenderer({data, row, cell}: any) {
  return <TextRenderer row={row} cell={cell} />;
}

function formatElement(data: any) {
  return data;
}

function formatData(data: Array<any>) {
  return data.map(d => formatElement(d));
}

function UnLocationCode({
  componentIndex
}: {
  componentIndex: number
}) {
  useFunction({invokers: {
    ifmsReferenceFilesSave: save,
    ifmsReferenceFilesCancel: cancelOperation,
  }});
  useFunctionKeys({onEsc: cancelOperation});

  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const { selectTableRow, tableNavigationCleanup } = useTableNavigation('codes-region-unloc-list', onRowSelect, selectUnLocForView, ['unCode'], false, false, false);

  const tableRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, dataRef] = useFastStorage(`ifms-referenceFiles-region-unloc-list`, []);
  const [selectedRow, setSelectedRow] = useState(-1);

  const [unLocationCode, _setUnLocationCode, removeUnLocationCodeFromStorage, unLocationCodeRef] = useTypedFastStorage<CodeOceanUnPort>(`ifms-referenceFiles-unloc-editable`, null);
  const [orderBy, setOrderBy] = useFastStorage(`ifms-referenceFiles-region-unloc-orderby`, {
    orderBy: 'unCode',
    orderByAscending: true,
    //general1: 'UNCode',
    //generalText1: '',   //<pt220819>
    //pageSize: systemSettings.defaultPageSize,
  });

  const { setCleanState, dirtyCleanup } = useDirtyCheck(`ifms-referenceFiles-region-unloc-type-editable`, ['edit', 'view']);
  const listSec = findSecurityTask(appContext, FmsSecTask.CodeUNLocation);

  const tableHeight = 520;
  const listItemType = 'CodeUNLocationListItem';
  
  const { FilterButton, search } = useFilterBar(
    codesRegionUnLocationCodeList,
    undefined,
    getDefaultOrderBy,
    String(componentIndex)
  );

  function getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'unCode',
      orderByAscending: true,
    };
  }

  function setUnLocationCode(b: any, skipDirty: boolean = false) {
    if (!skipDirty) {
      setHasChanges(true);
    }
    _setUnLocationCode(b);
  }

  function setData(d:Array<any>) {
    removeData();
    _setData(d);
  }

  async function fetchData(api:any, search:Search) {
    setLoading(true);

    const apiResult = await api.getListItems(JobNames.UNLocation,
      listItemType,
      CodeUNLocationListItem.calculateSearchParameters(search),
      1, search.pageSize);

    const fetchedTableData  = formatData(apiResult && apiResult.entities ? apiResult.entities : []);
    sortingListData(CodeUNLocationListItem, fetchedTableData , setData, orderBy);
    setLoading(false);
    setHasChanges(false);
  }

  useEffect(() => {
    if (isFilterObjectEmpty(search) && search.version === 1) reload(false);
    
    return () => {
      removeData();
      tableNavigationCleanup();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (loading || (isFilterObjectEmpty(search) && search.version === 1)) {
      return;
    }
    fetchData(appContext.api, search);
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search]
  );

  useEffect(() => {
    if (dataRef.current?.length > 0 && !loading) {
      selectTableRow(0, true);
      onRowSelect(0);
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  async function reload(clearAll:boolean = true) {
    const searchValue = clearAll ? initialSearch : search;
    await fetchData(appContext.api, searchValue);
  }

  function onRowSelect(rowIndex: number) {
    setSelectedRow(!isNaN(rowIndex) ? rowIndex : -1 );
  }

  async function setUnLocDetail(isView: boolean, row: number = -1) {
    const tempRow = row > -1 ? row : selectedRow;  // row double click시 row 값에 rowindex가 들어옴. 이를 우선시 해서 사용함. 

    if (tempRow >= 0 && tempRow < dataRef.current.length && _.isEmpty(unLocationCode)) {
      const apiResult: ApiResult<CodeOceanUnPort> = await appContext.api.getJobDetail(JobNames.UNLocation,
        { id: dataRef.current[tempRow].id});
      if (!apiResult || !apiResult.success) {
        await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
        return null;
      } else {
        const detailData = { ...apiResult.result, edit: true, view: isView, editIndex: selectedRow};
        setCleanState(detailData);
        const tEntity = new CodeOceanUnPort(detailData);
        tEntity.trackable = true;
        setUnLocationCode(tEntity, true);
      }
    }
  }

  function selectForNew() {
    const newModel = new CodeOceanUnPort();
    newModel.edit = false;
    newModel.view = false;
    newModel.isNew = true;
    setUnLocationCode(newModel, false);
    setCleanState(newModel);

    if(unLocationCodeRef.current) {
      unLocationCodeRef.current.trackable = true;
      setUnLocationCode( {
        edit : false,
        view: false,
      });
    }
  }

  async function selectUnLocForView(row:number) {
    await setUnLocDetail(true, row);
  }
  
  async function selectUnLocForEdit() {
    await setUnLocDetail(false);
  }

  async function selectUnLocForDelete(){
    const doConfirm = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    , false, 0, true, 'warning');
    if (doConfirm) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.UNLocation, { id:dataRef.current[selectedRow].id , pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        await reload(false);
      } 
      else
        showGlobalOkDialog(<p>{"Cannot delete"}</p>);
    } 
    else
      return;
  }

  function cancelOperation() {
    const filterNode = document.getElementById('ifms-list-screen-filter');
    const channel = postal.channel('ifms-filter');

    if (!filterNode) {
      setHasChanges(false);
      removeUnLocationCodeFromStorage();
    } else {
      channel.publish('ifms-filter.dismiss');
    }
    return true;
  }

  async function checkDataAsync(): Promise<boolean>{
    if(!unLocationCode || !unLocationCodeRef.current){
      return true;
    }

    const unl = unLocationCodeRef.current;
    if(!unLocationCodeRef?.current.unCode || unLocationCodeRef.current.unCode.length !== 5){
      await showGlobalOkDialog(<p>Please fill out the [UnCode] (Fixed Length: 5)</p>);
      return false;
    } else if(unLocationCodeRef.current.unCode.length === 5 && checkPropDirty(unl, 'unCode')){
      if(await appContext.api.selectUnPort(unLocationCodeRef.current.unCode, unLocationCodeRef.current.id)){
        await showGlobalOkDialog(<p>Duplicate Number in [UNCode]</p>);
        return false;
      }
      return true;
    }
    return true;
  }

  async function deleteEntity() {
    if(!unLocationCode){
      return;
    }
    if(unLocationCode.isNew){
      cancelOperation();
      return;
    }

    const doDelete = await showGlobalYesNoDialog(<p>Are you sure you want to delete?</p>, false, 0, true, 'warning');
    if(!doDelete){
      return;
    }
    const apiResult = await appContext.api.deleteJobDetail(JobNames.UNLocation, { id: unLocationCode.id});
    if(!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.SAVE_ERROR_MESSAGE}</p>);
      return;
    }
    cancelOperation();
    await reload(false);
  }

  async function save() {
    if(!unLocationCode){
      return;
    }
    if(!unLocationCodeRef.current?.isDirty){
      if(!unLocationCode.edit){
        const isDataValid = await checkDataAsync();
        if(!isDataValid){
          return;
        }
      }
      cancelOperation();
      reload(false);
      return;
    }else{
      const isDataValid = await checkDataAsync();
      if(!isDataValid){
        return;
      }
      cancelOperation();
    }
    const sqlInfoList = getSQLInfoList(unLocationCode);
    const apiResult = await appContext.api.saveJobDetail(JobNames.UNLocation, sqlInfoList);

    if (apiResult && apiResult.success) {
      await showGlobalOkDialog(<p>The data has been saved</p>);

      if (apiResult.result) {
        const insresult = apiResult.result.insertList[0].newId;
        if (insresult) {
          const newItem: any = {
            id: insresult,
            unCode: unLocationCode.unCode,
            unCodeSub: unLocationCode.unCodeSub,
            unPortName: unLocationCode.unPortName,
            unCountry: unLocationCode.unCountry,
            unCountryName: unLocationCode.unCountryName,
            unCityName: unLocationCode.unCityName,
            subDiv: unLocationCode.subDiv,
            usCode: unLocationCode.usCode,
          };
          const newList = _.cloneDeep(data)
          newList.splice(0, 0, newItem);
          setData(formatData(newList));

          selectTableRow(0);
        }
      }
      else {
        const editItem = data.find((x: any) => x.id === unLocationCode.id);
        editItem.unCode = unLocationCode.unCode;
        editItem.unCodeSub = unLocationCode.unCodeSub;
        editItem.unPortName = unLocationCode.unPortName;
        editItem.unCountry = unLocationCode.unCountry;
        editItem.unCountryName = unLocationCode.unCountryName;
        editItem.unCityName = unLocationCode.unCityName;
        editItem.subDiv = unLocationCode.subDiv;            
        editItem.usCode = unLocationCode.usCode;

        const insIndex = data.findIndex((x:any) => x.id === unLocationCode.id);
        const newList = _.cloneDeep(data);
        newList.splice(insIndex, 1, editItem);
        setData(formatData(newList));

        selectTableRow(insIndex);
      }

      cancelOperation();
      dirtyCleanup(); 
    }
  }

  function onHeaderClick(header: any) {
    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({ orderByAscending: !orderBy.orderByAscending });
      } else {
        setOrderBy({ orderBy: header.id, orderByAscending: true });
      }
    }
    sortingListData(CodeUNLocationListItem, data, setData, orderBy);
  }
  
  const tableOptions:ApplicableTableSettings = {
    customTableId: 'codes-region-unloc-list',
    ref: tableRef,
    selectable: true,
    tableName: 'regionUnLocationList',
    ...codesRegionUnLocationCodeList,
    height: `${tableHeight}px`,
    data: data.map((x:any, i:number) => ({...x, indicator: (i + 1).toString()})),
    rowRenderers: [
      { accessor: 'indicator', Cell: TextRenderer },
      { accessor: 'unCode', Cell: UnCodeRenderer },
      { accessor: 'unPortName', Cell: UnPortNameRenderer },
      { accessor: 'unCountry', Cell: UnCountryRenderer },
      { accessor: 'usCode', Cell: UsCodeRenderer },
      //{ accessor: 'action', Cell: ActionRenderer },
    ],
    orderBy: [orderBy],
    onHeaderClick
  };

  const hasSelectedRow = !isNaN(selectedRow) && !(selectedRow < 0);
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;

  return (
    <div style={{ marginTop: '40px' }}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
      <h1>Region <FontAwesomeIcon icon={faAngleRight} />&nbsp;UN Location</h1>
        <div style={{width: '320px', fontWeight: 'bold'}}>
          <ClearableSearch initialValue={orderBy?.generalText1 || ''} onSearch={generalText1 => setOrderBy({general1: generalText1 ? orderBy?.orderBy : null, generalText1})} />
        </div>
      </Portal> */}

      {/* <div className="reference-codes-title-row">
        <div className="oi-doc-title-sub-row">

           <div style={{marginLeft: '10px', fontSize: '11px', fontWeight: 'bold'}}>
            Double Click UN Location to Edit
          </div> 
        </div> */}

      {/* <div style={{width: '320px', fontWeight: 'bold'}}>
        <ClearableSearch
          initialValue={orderBy?.generalText1 || ''}
          onSearch={async generalText1 => {
            await reload(generalText1 === null ? '' : generalText1);
          }}
        />
      </div> */}

      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', marginTop:'5px'}}>
          <div className="ifms-common-bar-element" style={{marginLeft:'66px'}}>
            <CloseButton name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
        </div>
      </Portal>

      {/* <div className="ifms-common-bar-element">
        <PrimaryInverseButton size="regular" disabled={loading} onClick={() => {cancelOperation(); reload(); }} data-tooltip="Refresh" >
          <FontAwesomeIcon icon={faSync} />
        </PrimaryInverseButton>
      </div> */}
      
      <div style={{ display: 'flex', width: '680px' }}>
        <div style={{ marginLeft: 'auto' }}></div>
        <div style={{ position: 'relative', top: '-4px' }}>
          <div style={{ display: 'none' }}>
            <FilterButton /> &nbsp;&nbsp;
          </div>
          <SecondaryButton name='codes-unloc-add-button' size="regular" disabled={!canBeAdd} onClick={selectForNew}>New</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-unloc-view-button' size="regular" disabled={!hasSelectedRow} onClick={selectUnLocForView}>View</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-unloc-edit-button' size="regular" disabled={!canBeEdit} onClick={selectUnLocForEdit}>Edit</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-unloc-delete-button' size="regular" disabled={!canBeDeleted} onClick={selectUnLocForDelete}>Delete</SecondaryButton>&nbsp;
          <BlackInverseButton name='list-screen-refresh' disabled={loading} size="large" onClick={() => { cancelOperation(); reload(false); }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton>
        </div>
      </div>
      {/* </div> */}

      <div style={{ width: '680px' }}>
        <SmartTable {...tableOptions} />
      </div>
      <IfmsModal
        width="760px"
        isBlueHeader
        isOpen={!!unLocationCode}
        title={unLocationCode && unLocationCode.edit ? (unLocationCode.view ? 'UN Location Code View' : 'UN Location Code Edit') : 'UN Location Code New'}
        onCancel={cancelOperation}
      >
        {!!unLocationCode &&
          <div className="report-popup">
            <UnLocDetails readonly={unLocationCode.view || !canBeEdit} unLoc={unLocationCode} onChange={setUnLocationCode} />
            <div className='report-footer'>
              {canBeEdit && !unLocationCode.view &&
                <SecondaryButton
                  name='unloc-detail-save-button'
                  size="regular"
                  style={{ width: '90px' }}
                  onClick={save}
                >
                  SAVE
                </SecondaryButton>
              }
              {canBeEdit && unLocationCode.view &&
                <SecondaryButton
                  name='unloc-detail-edit-button'
                  size="regular"
                  style={{ width: '90px' }}
                  onClick={() => setUnLocationCode({ edit: true, view: false })}
                >
                  Edit
                </SecondaryButton>
              }

              {!unLocationCode.isNew && !unLocationCode.view && listSec?.grantDel &&
                <SecondaryButton
                  size="regular"
                  name='unloc-detail-delete-button'
                  style={{ width: '90px' }}
                  onClick={deleteEntity}
                >
                  DELETE
                </SecondaryButton>
              }
              <SecondaryButton
                name='unloc-detail-close-button'
                size="regular"
                style={{ width: '90px' }}
                onClick={cancelOperation}>
                CANCEL
              </SecondaryButton>
            </div>
          </div>
        }
      </IfmsModal>
    </div>
  );
}

export default UnLocationCode;
